import { render, staticRenderFns } from "./Dfmgi-Statistics.vue?vue&type=template&id=bc7fba2c"
import script from "./Dfmgi-Statistics.vue?vue&type=script&lang=js"
export * from "./Dfmgi-Statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CImage: require('/vercel/path0/components/ui/c-image.vue').default})
